<template>
  <kst-section collapsible collapsed 
    :title="sectionTitle"
    :help-collapsed="sectionHelp_collapsed"
    :help-expanded="sectionHelp_expanded"
  >
    <SalesSearchList
      ref="mdlSalesSearchList"
      :warehouseList="warehouseList"
      @submit="handleSubmit"
    />

    <kst-number-with-date search-mode
      :catalog="Catalog"
      :data="userData"
      dateField="DraftDate"
      numberField="SalesDraftID"
      @search="handleSearch"
      @clear="handleClear"
    />
  </kst-section>
</template>

<script>
import Catalog from "../InvCatalog.js";
import Info from "../InvInfo.js";
import Model from "../InvModel.js";
import Services from "../../../services/Api/InvoiceServices.js";

import SalesSearchList from "../../Sales/SearchList/SlsScL.vue";

export default {
  components: {
    SalesSearchList
  },
  props: {
    userData: Object,
    warehouseList: Array
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionTitle() {
      return Info.Section.Sales.Title;
    },
    sectionHelp_collapsed() {
      return Model.getSalesSectionHelp(this.userData);
    },
    sectionHelp_expanded() {
      return Info.Message.New_Sales;
    }
  },
  methods: {
    handleSubmit(row) {
      this.$emit(this.$kst.Enum.Event.Submit, row);
    },

    handleClear() {
      this.$emit(this.$kst.Enum.Event.Reset);
    },
    handleSearch() {
      this.$refs.mdlSalesSearchList.show(
        Services.getRelatedSalesList,
        Services.getRelatedSalesDetails
      );
    }
  }
}
</script>